import {
  PbCreateNangoConnectSessionResponse,
  PbGroupNangoConnection,
  PbNangoConnection,
  PbNangoConnectionHealth,
  PbNangoConnectionHealthStateEnum,
  PbShopifyAppAutomationToken
} from '@itsrever/rever-api'
import {
  GroupNangoConnection,
  NangoConnectSession,
  NangoConnection,
  NangoConnectionHealth,
  ShopifyAppAutomationToken
} from '@/domain/nango-connection'

export function toNangoConnections(
  connections: PbNangoConnection[]
): NangoConnection[] {
  return connections
    .filter((c) => c.integration && c.connection_id)
    .map((c) => ({
      integration: c.integration ?? '',
      connectionId: c.connection_id ?? '',
      linkedAt: c.linked_at ? new Date(c.linked_at) : undefined
    }))
}

export function toNangoConnectSession(
  session: PbCreateNangoConnectSessionResponse
): NangoConnectSession {
  return {
    token: session.token ?? '',
    expiresAt: session.expires_at ? new Date(session.expires_at) : undefined
  }
}

export function toGroupNangoConnections(
  connections: PbGroupNangoConnection[]
): GroupNangoConnection[] {
  return connections
    .filter((c) => c.integration && c.connection_id)
    .map((c) => ({
      integration: c.integration ?? '',
      connectionId: c.connection_id ?? '',
      provider: c.provider ?? '',
      createdAt: c.created_at ? new Date(c.created_at) : undefined,
      linkedEcommerceIds: c.linked_ecommerce_ids ?? [],
      health: toNangoConnectionHealth(c.health),
      store: c.store || undefined
    }))
}

// A state this dashboard doesn't know reads as unchecked, not as working.
export function toNangoConnectionHealth(
  health?: PbNangoConnectionHealth
): NangoConnectionHealth | undefined {
  const state =
    health?.state === PbNangoConnectionHealthStateEnum.Ok
      ? 'ok'
      : health?.state === PbNangoConnectionHealthStateEnum.Invalid
        ? 'invalid'
        : undefined
  if (!state) return undefined
  return {
    state,
    platformError: health?.platform_error || undefined,
    failingSince: health?.failing_since
      ? new Date(health.failing_since)
      : undefined,
    checkedAt: health?.checked_at ? new Date(health.checked_at) : undefined,
    portalStore: health?.portal_store || undefined
  }
}

export function toShopifyAppAutomationToken(
  token: PbShopifyAppAutomationToken
): ShopifyAppAutomationToken {
  return {
    tokenSet: token.token_set ?? false,
    expiresAt: token.expires_at ? new Date(token.expires_at) : undefined,
    required: token.required ?? false
  }
}
